<!--  -->
<template>
  <div>
    <div class="tinymce_box">
      <div>
        <div class="tabselecr_box">
          <div class="tbwrw search_box">
            <el-input
              v-model="obj.employee_no"
              placeholder="请输入员工编号"
              style="width: 200px;"
            />
            <el-input
              v-model="obj.job_no"
              placeholder="请输入任务编号"
              style="width: 200px;"
            />
            <el-select
              v-model="obj.job_code"
              placeholder="请选择任务类型"
              style=""
              clearable
            >
              <el-option
                v-for="item in accountarr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
            <!-- <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker> -->
            <el-date-picker
              v-model="interactiontime"
              style="width:400px"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              @change="timechangerall"
            />
            <el-select
              v-model="obj.only_me"
              style=""
              placeholder="请选择"
            >
              <el-option
                v-for="item in zuarrw"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-select
              v-model="obj.result"
              style=""
              placeholder="请选择执行结果"
              clearable
            >
              <el-option
                v-for="item in zhixiarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="primary"
              style=""
              icon="el-icon-search"
              @click="searchclick"
            >搜索</el-button>
            <el-button
              type="info"
              icon="el-icon-refresh-right"
              @click="rechargeclick"
            >重置</el-button>
          </div>
          <!-- <div>
            <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
          </div> -->
        </div>

        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData.list"
          border
          tooltip-effect="dark"
          style="margin-top:20px"
        >
          <el-table-column
            prop="corp_name"
            label="企业"
            align="center"
          />
          <el-table-column
            prop="employee_name"
            label="员工名称"
            align="center"
          />
          <el-table-column
            prop="employee_no"
            label="员工编号"
            width="280"
            align="center"
          />
          <el-table-column
            prop="job_no"
            label="任务编号"
            width="380"
            align="center"
          />
          <el-table-column
            prop="job_code_text"
            label="任务类型"
            align="center"
          />
          <el-table-column
            prop="result_text"
            label="完成情况"
            align="center"
          />
          <el-table-column
            prop="created_at_text"
            label="下发时间"
            align="center"
          />
          <el-table-column
            prop="updated_at_text"
            label="完成时间"
            align="center"
          />
          <el-table-column
            prop="msg"
            label="文字说明"
            align="center"
            width="200"
          />
        </el-table>
        <pagination-right
          :current-page="obj.page"
          :total="tableData.total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
    </div>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { spWorkWechatlistr, workWechatcodeList } from '@/api/workWechat.js'
export default {
  components: { PaginationRight },
  mixins: [convertToHump],
  data() {
    const now = new Date()
    const year = now.getFullYear()
    const month = (now.getMonth() + 1).toString().padStart(2, '0')
    const day = now.getDate().toString().padStart(2, '0')
    const start = `${year}-${month}-01`
    const end = `${year}-${month}-${day}`
    return {
      tableData: [],
      obj: {
        page: 1,
        page_size: 10,
        job_code: null,
        employee_no: '',
        job_no: '',
        start,
        end,
        only_me: 1,
        result: ''
      },
      loading: false,
      accountarr: [],
      interactiontime: [start, end],
      zuarrw: [
        {
          value: 1,
          label: '查看组内任务'
        },
        {
          value: 2,
          label: '查看组外任务'
        }
      ],
      zhixiarr: [
        {
          value: 1,
          label: '成功'
        },
        {
          value: 2,
          label: '失败'
        },
        {
          value: 3,
          label: '待执行'
        }
      ]
    }
  },
  created() {
    this.typelist()
    this.menuList()
  },
  mounted() {},
  activated() {
    this.typelist()
    this.menuList()
  },
  methods: {
    async typelist() {
      const data = await workWechatcodeList(this.obj)
      this.accountarr = data.data
      console.log('data', data)
    },
    menuList() {
      this.loading = true
      spWorkWechatlistr(this.obj).then(res => {
        console.log('res', res)
        this.tableData = res.data
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.obj.page_size = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.menuList()
    },
    rechargeclick() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      const start = `${year}-${month}-01`
      const end = `${year}-${month}-${day}`

      this.obj.page = 1
      this.obj.job_code = null
      this.obj.employee_no = ''
      this.obj.job_no = ''
      this.obj.start = start
      this.obj.end = end
      this.interactiontime = [start, end] // 重点！让UI显示同步
      this.obj.only_me = 1
      this.obj.result = ''
      this.menuList()
    },
    searchclick() {
      // 校验日期区间
      if (this.obj.start && this.obj.end) {
        const startMonth = this.obj.start.slice(0, 7)
        const endMonth = this.obj.end.slice(0, 7)
        if (startMonth !== endMonth) {
          this.$message.warning('只能查询同一个月内的数据，请重新选择日期区间！')
          this.interactiontime = []
          this.obj.start = ''
          this.obj.end = ''
          return
        }
      }
      this.obj.page = 1
      this.menuList()
    },
    timechangerall(val) {
      if (!val || val.length !== 2) {
        this.obj.start = ''
        this.obj.end = ''
        return
      }
      const [start, end] = val
      // 取年月（yyyy-MM）
      const startMonth = start.slice(0, 7)
      const endMonth = end.slice(0, 7)
      if (startMonth !== endMonth) {
        this.$message.warning('只能选择同一个月内的日期区间！')
        this.interactiontime = []
        this.obj.start = ''
        this.obj.end = ''
        return
      }
      this.obj.start = start
      this.obj.end = end
    },
    getCurrentMonthRange() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      const start = `${year}-${month}-01`
      const end = `${year}-${month}-${day}`
      return [start, end]
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tinymce_box {
  /* width: 1200px;
  margin: 0 auto;
  margin-top: 50px; */
  padding: 30px;
}
.tinymceserve_box {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.inpuwbox {
  width: 200px;
  margin-left: 20px;
}
.functional_area {
  margin-top: 20px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.choose_plate {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_text {
  font-size: 14px;
  color: #606266;
}
.template_addbutton {
  text-align: right;
  width: 80%;
}
.sewrw_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.search_box {
  display: flex;
  align-items: center;
}
.content_box {
  /* width: 130px; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.tbwrw {
  display: flex;
  align-items: center;
}
</style>
